export const colWidths = [

  45, //checkbox
  // 80,//userid
  150, //primary location
  100, //first Name
  100, //Middle Name
  120, //Last Name
  50, //suffix
  160, //Email
  100, //Phone
  // 160, //Location Access User Rights
  160, //Task Locations
  100, //Department
  100, //User status
  180, //Pinned views for Myview
  150, //Default Myview ,
  150, // default category,
  // 80, //Part time
  120, //Employee ID
  150, //User Rights Group
  100, //Title/Level
  180, // IP Adress restriction
  130, //Industry Group
  120, //Niche Group
  120, // Expertise
  // 150, //Residence City
  150, // Primary Role
  150, // Secondary Role
  150, //Wrk Exp Begindate
  180, // Years Of Experience
  100, //Primary Billing Rate
  100, //Secondary Billing Rate
  160, //Last logged on
];
